import styled from "styled-components";
import { Link } from "react-router-dom";

export const Logo = styled.div`
  height: 32px;
  margin: 16px;
  font-size: 22px;
  line-height: 1;
  text-align: center;
  font-weight: 700;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const MenuLink = styled(Link)`
  font-size: 14px !important;
`;
